import { createRouter, createWebHistory } from "vue-router";
import AutorizationPage from "@/pages/AutorizationPage.vue";
const routes = [
  {
    path: "/",
    name: "auth",
    component: AutorizationPage,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
